<template>
  <div>
    <sub-header />

    <vision   class="py-8 py-md-16" id="vision" />
    <ceo      class="py-8 py-md-16" id="ceo" style="background: #f5f5f5" />
    <history  class="py-8 py-md-16" id="history" />
    <customer class="py-8 py-md-16" id="customer" style="background: #f5f5f5" />
    <location class="py-8 py-md-16" id="location" />

    
  </div>
</template>

<script>
import vision from '@/components/company/vision.vue'
import ceo from '@/components/company/ceo.vue'
import history from '@/components/company/history.vue'
import customer from '@/components/company/customer.vue'
import location from '@/components/company/location.vue'


export default {
  name: 'company',
  components: { 
    vision,
    ceo,
    history,
    customer,
    location,
  },



  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
  },

  methods: {
  }

};
</script>
